<div>
    <button *ngIf="hasPermissions('manage_distributors')" style="margin: 15px" class="floatR marginB" nz-button nzType="primary" nzShape="circle" (click)="showModal(false)">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
    </button>

    <div style="padding: 20px">
      <nz-input-group nzPrefixIcon="search">
        <input style="padding: 10px" (keyup)="search($event)" type="text" nz-input placeholder="Search by Distributor or Phone" />
      </nz-input-group>
    </div>

    <div>
        <nz-table #distributorTable [nzLoading]="loading" [nzData]="distributorsList">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Providers</th>
              <th>Companies</th>
              <th *ngIf="hasPermissions('manage_distributors')"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of distributorTable.data" nzShowSizeChanger>
              <td>{{d.name}}</td>
              <td>{{d.phone}}</td>
              <td>{{d.providers?.length || 0}}</td>
              <td>{{d.companies}}</td>
              <td *ngIf="hasPermissions('manage_distributors')">
                <button (click)="showModal(d)" nz-button nzType="primary" nzShape="circle">
                  <span nz-icon nzType="edit" nzTheme="outline"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
</div>


<nz-modal [(nzVisible)]="isModalVisible" nzTitle="Distributor" nzCentered (nzOnCancel)="cancelAddEdit()" (nzOnOk)="confirmAddEdit()">
    <ng-container *nzModalContent>
      <form [formGroup]="distributorForm">
        <nz-form-item>
          <nz-form-label nzRequired>Name</nz-form-label>
            <input nz-input formControlName="name"/>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label nzRequired>Phone</nz-form-label>
            <input nz-input mask="(000) 000-0000" formControlName="phone"/>
        </nz-form-item>
        
        <nz-form-item>
          <nz-form-label>Companies</nz-form-label>
          <nz-select nzMode="multiple" nzPlaceHolder="Select Companies" formControlName="companies" style="width: 100%;">
            <nz-option [nzDisabled]="c.distributor_id !== null && c.distributor_id != distributorForm.get('id')?.value" *ngFor="let c of companies" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
          </nz-select>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Providers</nz-form-label>
          <nz-select nzMode="multiple" nzPlaceHolder="Select providers" formControlName="providers" style="width: 100%;">
            <nz-option *ngFor="let p of providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
          </nz-select>
        </nz-form-item>
      </form>
    </ng-container>
</nz-modal>
